import * as React from "react"

import { Layout } from "../components/layout/layout"
import Seo from "../components/seo"
import { CenteredLayout } from "../styles/base-styles"

const NotFoundPage = () => (
  <Layout>
    <Seo title="404: Not found" />
    <CenteredLayout
      size={880}
      mobilePadding={15}
      style={{ paddingBottom: 80, paddingTop: 80, textAlign: "center" }}
    >
      <h1>Not Found</h1>
    </CenteredLayout>
  </Layout>
)

export default NotFoundPage
